export const USER_ROUTES = {
  ORDERS: '/order/overview/' as const,
};
